var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    title: "Edit icon",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6267 7.45306C16.745 7.33484 16.8389 7.19445 16.903 7.03992C16.967 6.88539 17 6.71975 17 6.55246C17 6.38518 16.967 6.21954 16.903 6.06501C16.8389 5.91048 16.745 5.77009 16.6267 5.65187L14.3481 3.37333C14.2299 3.25498 14.0895 3.16109 13.935 3.09703C13.7805 3.03297 13.6148 3 13.4475 3C13.2803 3 13.1146 3.03297 12.9601 3.09703C12.8056 3.16109 12.6652 3.25498 12.5469 3.37333L3 12.9203V17H7.07973L16.6267 7.45306ZM13.4444 4.27074L15.7293 6.55565L13.8199 8.46503L11.535 6.18013L13.4444 4.27074ZM4.27293 15.7271V13.4422L10.6376 7.07755L12.9225 9.36245L6.55783 15.7271H4.27293Z",
    fill: "#0A5A67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.ee4b9ceb.svg";
export { ForwardRef as ReactComponent };